module.exports = __webpack_public_path__ + "img/checkmark.9b41d188.svg";